import { api } from '@api'
import { NoteToCreate, Ticket } from '@types'

interface ApproveTicketsResponse {
  ticket: Ticket
}
interface ApproveTicketPayload {
  id: number
  note?: NoteToCreate
  type?: string
}

const approveTicket = async ({ id, note, type }: ApproveTicketPayload) => {
  const response = await api.put<ApproveTicketsResponse>(`/tickets/${id}/approve`, {
    note: { ...note },
    type,
  })

  return response.data
}

export const TicketsApi = { approveTicket }
